// extracted by mini-css-extract-plugin
export default {"page":"Home_page__OUVS-","split":"Home_split__F21d1"};